import A from 'components/atoms/A/A';
import Card from 'components/atoms/Card/Card';
import Currency from 'components/atoms/Currency/Currency';
import Txt from 'components/atoms/Txt/Txt';
import React from 'react';
import classes from './Dashboard.module.scss';

export type SummaryCardProps = {
  title: string;
  current: {
    amount: number;
    currency: string;
  };
  linkTo: string;
};

export function SummaryCard({ title, current, linkTo }: SummaryCardProps) {
  return (
    <A href={linkTo} className={classes.summaryCardLink}>
      <Card isLink className={classes.summaryCard}>
        <div className={classes.summaryCardTitleRow}>
          <Txt className={classes.summaryTitle}>{title}</Txt>
          <Txt className={classes.summaryViewMore}>View</Txt>
        </div>
        <div className={classes.summaryAmountRow}>
          <span className={classes.summaryAmountPrefix}>+</span>
          <Currency
            className={classes.summaryAmount}
            amount={current.amount}
            currency={current.currency}
          />
        </div>
      </Card>
    </A>
  );
}
